// extracted by mini-css-extract-plugin
module.exports = {"articles":"SearchQueryArticles_articles__3L_gZ"};